import {
  administrationFilterSettingsPath,
  administrationRulesListPath,
  administrationRulesPageablePath,
  administrationTableActionsSettingsPath,
  administrationTableSettingsPath,
  updateFilterSettingsPath,
  updateTableActionsSettingsPath,
  updateTableSettingsPath,
} from '../constants/apiEndpoints';
import { locale, notificationType } from '../constants/globals';
import { administrationActions } from '../reducers/administration';
import { createNotification, formatText } from '../utils';
import { errorAction } from '../utils/actions';
import apiService from '../utils/apiService';

export const fetchAllAdministrationRulesPageable = (pageNumber, pageSize) => {
  return (dispatch) => {
    dispatch(administrationActions.actionStart());
    return apiService
      .get(administrationRulesPageablePath(pageNumber, pageSize))
      .then((response) => {
        dispatch(
          administrationActions.fetchAllAdministrationRulesPageable(
            response.data
          )
        );
      })
      .catch((err) => {
        dispatch(administrationActions.actionError(err?.response?.data));
      });
  };
};

export const fetchFilterSettings = (
  tableName,
  language = locale.default.toUpperCase()
) => {
  return (dispatch) => {
    dispatch(administrationActions.actionSettingsStart());
    return apiService
      .get(administrationFilterSettingsPath(tableName, language))
      .then((response) => {
        dispatch(administrationActions.fetchFilterSettings(response.data));
      })
      .catch((err) => {
        dispatch(administrationActions.actionError(err?.response?.data));
      });
  };
};

export const fetchTableSettings = (
  id,
  language = locale.default.toUpperCase()
) => {
  return (dispatch) => {
    dispatch(administrationActions.actionSettingsStart());
    return apiService
      .get(administrationTableSettingsPath(id, language))
      .then((response) => {
        dispatch(administrationActions.fetchTableSettings(response.data));
      })
      .catch((err) => {
        dispatch(administrationActions.actionError(err?.response?.data));
      });
  };
};

export const fetchTableActionsSettings = (
  id,
  language = locale.default.toUpperCase()
) => {
  return (dispatch) => {
    dispatch(administrationActions.actionSettingsStart());
    return apiService
      .get(administrationTableActionsSettingsPath(id, language))
      .then((response) => {
        dispatch(administrationActions.fetchTableSettings(response.data));
      })
      .catch((err) => {
        dispatch(administrationActions.actionError(err?.response?.data));
      });
  };
};

export const updateFilterSettings = (
  payload,
  messages,
  callback,
  tableName,
  language = locale.default.toUpperCase()
) => {
  return (dispatch) => {
    dispatch(administrationActions.actionSettingsStart());
    return apiService
      .put(updateFilterSettingsPath(language), payload)
      .then(() => {
        dispatch(administrationActions.actionStopSettingsLoading());
        const messageText = formatText(
          messages.successFilterSettings,
          tableName
        );
        createNotification(
          notificationType.success,
          messages.title,
          messageText
        );
        callback();
      })
      .catch((err) => {
        errorAction(
          err,
          administrationActions.actionSettingsError,
          dispatch,
          messages
        );
      });
  };
};

export const updateTableSettings = (
  requestData,
  messages,
  callback,
  tableName,
  language = locale.default.toUpperCase()
) => {
  return (dispatch) => {
    dispatch(administrationActions.actionSettingsStart());
    return apiService
      .put(updateTableSettingsPath(language), requestData)
      .then(() => {
        dispatch(administrationActions.actionStopSettingsLoading());
        const messageText = formatText(
          messages.successTableSettings,
          tableName
        );
        createNotification(
          notificationType.success,
          messages.title,
          messageText
        );
        callback();
      })
      .catch((err) => {
        errorAction(
          err,
          administrationActions.actionSettingsError,
          dispatch,
          messages
        );
      });
  };
};

export const deleteErrorAdministrationRules = () => {
  return (dispatch) => {
    dispatch(administrationActions.clearError());
  };
};

export const fetchAllAdministrationRules = () => {
  return (dispatch) => {
    dispatch(administrationActions.actionStart());
    return apiService
      .get(administrationRulesListPath())
      .then((response) => {
        dispatch(
          administrationActions.fetchAllAdministrationRules(response.data)
        );
      })
      .catch((err) => {
        dispatch(administrationActions.actionError(err?.response?.data));
      });
  };
};

export const clearSettings = () => {
  return (dispatch) => {
    dispatch(administrationActions.updateTableSettings([]));
  };
};

export const clearAdministrationRulesList = () => {
  return (dispatch) => {
    dispatch(administrationActions.fetchAllAdministrationRules([]));
  };
};

export const updateTableActionsSettings = (
  requestData,
  messages,
  callback,
  tableName,
  language = locale.default.toUpperCase()
) => {
  return (dispatch) => {
    dispatch(administrationActions.actionSettingsStart());
    return apiService
      .put(updateTableActionsSettingsPath(language), requestData)
      .then(() => {
        dispatch(administrationActions.actionStopSettingsLoading());
        const messageText = formatText(
          messages.successTableActionsSettings,
          tableName
        );
        createNotification(
          notificationType.success,
          messages.title,
          messageText
        );
        callback?.();
      })
      .catch((err) => {
        errorAction(
          err,
          administrationActions.actionSettingsError,
          dispatch,
          messages
        );
      });
  };
};
